import { Component } from "react"
import PropTypes from "prop-types"
import CompareSearch from "../compare-search"
import { Button } from "@mui/material"

class AddOptions extends Component {
  static propTypes = {
    account: PropTypes.string.isRequired,
    openDialog: PropTypes.func.isRequired,
    modelId: PropTypes.string.isRequired,
    searchItemsActions: PropTypes.object.isRequired,
    disableSearchResult: PropTypes.func.isRequired,
    trackExperimentTypeSelection: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
  }

  openCompareSearch = () => {
    const { account, openDialog, modelId, searchItemsActions, disableSearchResult, trackExperimentTypeSelection } = this.props
    trackExperimentTypeSelection("search")
    openDialog({
      title: "Search For Comparison",
      content: <CompareSearch account={account} modelId={modelId} itemsActions={searchItemsActions} disableSearchResult={disableSearchResult} />,
    })
  }

  render() {
    const { disabled } = this.props
    return <Button disabled={disabled} color="primary" onClick={this.openCompareSearch} variant="text">
      + Add Comparison
    </Button>
  }
}

export default AddOptions
